/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/pages/auth/AuthPage`, `src/pages/home/HomePage`).
 */

import React, { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { useLastLocation } from "react-router-last-location";
import AuthPage from "../pages/auth/AuthPage";
import LogoutPage from "../pages/auth/Logout";
import ErrorsPage from "../pages/errors/ErrorsPage";
import HomePage from "../pages/home/HomePage";
import TermosUsoPage from "../pages/termos-uso/TermosUsoPage";
import * as routerHelpers from "../router/RouterHelpers";
import { actions } from "../store/ducks/config.duck";
import { LayoutContextProvider } from "../../_metronic";

export const Routes = withRouter(({ history }) => {
    const lastLocation = useLastLocation();

    routerHelpers.saveLastLocation(lastLocation);

    const { isAuthorized, menuConfig, userLastLocation } = useSelector(
        ({ auth, _urls, builder: { menuConfig } }) => ({
            menuConfig,
            isAuthorized: auth.user != null,
            userLastLocation: routerHelpers.getLastLocation(),
        }),
        shallowEqual,
    );

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actions.requestPhone());
    }, [dispatch]);

    return (
        /* Create `LayoutContext` from current `history` and `menuConfig`. */
        <LayoutContextProvider history={history} menuConfig={menuConfig}>
            <Switch>
                <Route path="/termos-de-uso" component={TermosUsoPage} />

                {!isAuthorized ? (
                    /* Render auth page when user at `/auth` and not authorized. */
                    <AuthPage />
                ) : (
                    /* Otherwise redirect to root page (`/`) */
                    <Redirect from="/auth/login" to={userLastLocation} />
                )}

                <Route path="/error" component={ErrorsPage} />
                <Route path="/logout" component={LogoutPage} />

                {!isAuthorized ? (
                    /* Redirect to `/auth` when user is not authorized */
                    <Redirect to="/" />
                ) : (
                    <HomePage userLastLocation={userLastLocation} />
                )}
            </Switch>
        </LayoutContextProvider>
    );
});
